import type { CapiProductPage } from 'types/capi/pdp';

import {
  type ContractStockStatus,
  toContractStockStatus
} from '~/domain/stockStatus';

type PdpViewProperties = {
  num_of_listings: number;
  price_currency: string;
  price_regular: number;
  price_sale?: number;
  product_id: string;
  stock_status: ContractStockStatus;
};

const NO_PRICE = -1;

export function getPdpViewProperties(
  product: CapiProductPage
): PdpViewProperties {
  return {
    num_of_listings: product.stock_listings.affiliates.length,
    price_currency: product.price.currency,
    price_regular: product.price.regular ?? NO_PRICE,
    price_sale: product.price.sale ?? undefined,
    product_id: String(product.product_id),
    stock_status: toContractStockStatus(product.stock_status)
  };
}
